module.exports = __webpack_public_path__ + "img/avatar-83.b064fa91.png";